import { render, staticRenderFns } from "./RewardLogs.vue?vue&type=template&id=aba54702"
import script from "./RewardLogs.vue?vue&type=script&lang=js"
export * from "./RewardLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports